// extracted by mini-css-extract-plugin
export default {"loading":"index_loading__y0aUS","absolute":"index_absolute__8t2VP"};